import { render, staticRenderFns } from "./DatosStudentListGroup.vue?vue&type=template&id=788c3416"
import script from "./DatosStudentListGroup.vue?vue&type=script&lang=js"
export * from "./DatosStudentListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports